import classnames from "classnames";
import React, { Fragment, useEffect, useRef, useState } from "react";

import { FlyoutCategory } from "@redux/modules/value/flyoutCategories/flyoutCategories.types";
import { useGranite } from "@redux/modules/value/translations/translations.provider";

import { LanguageSelectorSidebar } from "@components/General/LanguageSelector/languageSelectorSidebar.container";

import AccountLinks from "./accountLinks/accountLinks.container";
import { Submenu } from "./subMenu/subMenu.component";
import { SubmenuFlyoutPanel } from "./subMenu/subMenuFlyoutPanel.component";

type Props = {
    active: boolean;
    data?: FlyoutCategory;
    innerHTML?: string;
    profileLink: string;
    accountLinks: Array<any>;
    update: () => void;
};

const Sidebar = ({
    active,
    data,
    innerHTML,
    profileLink,
    accountLinks,
    update,
}: Props) => {
    const { t } = useGranite();

    const [assortiment, setAssortiment] = useState(false);
    const [category, setCategory] = useState(null);
    const [subcategory, setSubcategory] = useState(null);

    const headerElementRef = useRef<HTMLElement>(
        document.querySelector(".navigation__search"),
    );

    useEffect(() => {
        if (!active) {
            if (category || subcategory) {
                reset();
            }
        }
    }, []);

    const reset = () => {
        setCategory(null);
        setSubcategory(null);
        setAssortiment(false);
    };

    const handleCategoryClose = (e: Event) => {
        e.preventDefault();
        e.stopPropagation();
        setCategory(null);
    };

    const handleSubCategoryClose = (e: Event) => {
        e.preventDefault();
        e.stopPropagation();
        setSubcategory(null);
    };

    const handleClick = (e: Event) => {
        e.preventDefault();
        e.stopPropagation();
        setAssortiment(!assortiment);
    };

    const offsetTop = headerElementRef.current?.getBoundingClientRect().bottom;

    return (
        <>
            {active && (
                <div
                    className="sidebar__container"
                    style={{
                        paddingTop: `${offsetTop}px`,
                    }}
                >
                    <div className="sidebar">
                        <div
                            // @ts-ignore
                            onClick={handleClick}
                            className={classnames(
                                "sidebar__assortiment",
                                "sidebar__item",
                                "sidebar__item--underlined",
                            )}
                        >
                            <a href="#">{t("sideBar.link.productRange")}</a>
                            <i
                                className={classnames(
                                    "sidebar__assortiment__chevron",
                                    assortiment &&
                                        "sidebar__assortiment__chevron__active",
                                    "las la-angle-down text-info",
                                )}
                            />
                        </div>
                        {assortiment && (
                            <Submenu
                                subCategories={data?.subCategories || []}
                                root
                                level={0}
                                onClick={(hasChildren, data) =>
                                    // @ts-ignore
                                    hasChildren ? setCategory(data) : undefined
                                }
                            />
                        )}
                        <div
                            // @ts-ignore
                            dangerouslySetInnerHTML={{ __html: innerHTML }}
                        />
                        <AccountLinks
                            menuItems={accountLinks}
                            profileLink={profileLink}
                        />
                        <LanguageSelectorSidebar />
                    </div>

                    {category && (
                        <SubmenuFlyoutPanel
                            offsetTop={offsetTop}
                            data={category}
                            level={1}
                            onClick={(hasChildren, data) =>
                                // @ts-ignore
                                hasChildren ? setSubcategory(data) : undefined
                            }
                            onClose={e => handleCategoryClose(e)}
                        />
                    )}
                    {subcategory && (
                        <SubmenuFlyoutPanel
                            offsetTop={offsetTop}
                            data={subcategory}
                            level={2}
                            onClick={(hasChildren, data) =>
                                // @ts-ignore
                                hasChildren ? setSubcategory(data) : undefined
                            }
                            onClose={e => handleSubCategoryClose(e)}
                        />
                    )}
                </div>
            )}

            <div
                onClick={() => update()}
                className={classnames(
                    "sidebar__lightbox",
                    active && "modal-backdrop fade show",
                )}
            />
        </>
    );
};

export default Sidebar;
